import { createColumnHelper } from '@tanstack/react-table';
import { customTemplatesQuery } from 'components/domain/automation/customTemplates/customTemplatesQuery';
import CommonTable from 'components/table/CommonTable';
import useServerFilteredTable from 'components/table/hooks/useServerFilteredTable';
import { CustomTemplate } from 'models/automation/CustomTemplates';
import { useTranslation } from 'react-i18next';
import { useIsMutating } from '@tanstack/react-query';
import useSearchedCustomTemplates from '../useSearchedCustomTemplates';
import ActionsCell from './cells/ActionsCell';
import { DUPLICATE_CUSTOM_TEMPLATE_MUTATION_KEY } from './actions/useDuplicateCustomTemplate';

const CustomTemplatesTable = () => {
  const searchTerm = useSearchedCustomTemplates();
  const { t } = useTranslation();
  const isDuplicatingCustomTemplate =
    useIsMutating({
      mutationKey: [DUPLICATE_CUSTOM_TEMPLATE_MUTATION_KEY],
    }) > 0;
  const columnHelper = createColumnHelper<CustomTemplate>();

  const columns = [
    columnHelper.accessor('name', {
      header: t('pageAutomations.customTemplates.table.name'),
      sortDescFirst: true,
    }),
    columnHelper.accessor('messagingType', {
      header: t('pageAutomations.customTemplates.table.type'),
      cell: ({ getValue }) =>
        t('pageAutomations.customTemplates.types.messagingType', {
          context: getValue(),
        }),
    }),
    columnHelper.display({
      id: 'actions',
      header: t('common.actions'),
      cell: ActionsCell,
      meta: {
        showCellTooltip: false,
      },
    }),
  ];

  const { tableInstance, isLoading } = useServerFilteredTable({
    columns,
    getQuery: (options) =>
      customTemplatesQuery({ ...options, name: searchTerm }),
    pageSize: 20,
  });

  return (
    <CommonTable
      data-testid="custom-templates-table"
      emptyState={t('pageAutomations.customTemplates.table.emptyTable')}
      isLoading={isLoading || isDuplicatingCustomTemplate}
      tableInstance={tableInstance}
    />
  );
};

export default CustomTemplatesTable;
